import dynamic from 'next/dynamic'

export const DynamicWelcomeModal = dynamic(() => import('.').then((mod) => mod.WelcomeModal), {
  ssr: false,
})
